export class HTCCodeHelper{
    public static formatHTCCode(value: string) {
        if (!value)
            return '';

        if (new RegExp(/\d{4}\.\d{2}\.\d{4}$/).test(value) == true)
            return value;

        const splittedArray = value.split('.');

        return [splittedArray[0], splittedArray[1], [splittedArray[2], splittedArray[3]].join('')].join('.');
    }
}


// WEBPACK FOOTER //
// ./app/common/helpers/HTCCodeHelper.ts